<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="headerthirtyninth01" class="chapter" epub:type="chapter" id="thirtyninth" role="doc-chapter">
<header id="headerthirtyninth01">
<h1 class="ct"><a class="xref" href="#/chilashvol20005#toc">The Thirty-Ninth Congress</a></h1>
<h1 class="cs" role="doc-subtitle">Membership<a class="fnref" href="#/chilashvol20268#fn1" id="fn1r" role="doc-noteref">1*</a></h1>
</header>
<ul style="list-style-type:none">
<li class="ulf">Alabama
          <ul style="list-style-type:none">
<li class="ul1">Senators
              <ul style="list-style-type:none">
<li class="ul2">Vacant</li>
</ul>
</li>
<li class="ul1">Representatives<sup class="footnote-out"><a class="enref" href="#/chilashvol20267#en2" id="en2r" role="doc-noteref">1</a></sup>
<ul style="list-style-type:none">
<li class="ul2">Vacant</li>
</ul>
</li>
</ul>
</li>
<li class="ulf">Arkansas
          <ul style="list-style-type:none">
<li class="ul1">Senators
              <ul style="list-style-type:none">
<li class="ul2">Vacant</li>
</ul>
</li>
<li class="ul1">Representatives
              <ul style="list-style-type:none">
<li class="ul2">Vacant</li>
</ul>
</li>
</ul>
</li>
<li class="ulf">California
          <ul style="list-style-type:none">
<li class="ul1">Senators
              <ul style="list-style-type:none">
<li class="ul2">John Conness, <i>San Francisco</i></li>
<li class="ul2">James A. McDougall, <i>Sacramento</i></li>
</ul>
</li>
<li class="ul1"><span class="page" data-locator="p14"></span>Representatives
              <ul style="list-style-type:none">
<li class="ul2">Donald C. McRuer, <i>San Francisco</i></li>
<li class="ul2">William Higby, <i>Calaveras</i></li>
<li class="ul2">John Bidwell, <i>Chico</i></li>
</ul>
</li>
</ul>
</li>
<li class="ulf">Connecticut
          <ul style="list-style-type:none">
<li class="ul1">Senators
              <ul style="list-style-type:none">
<li class="ul2">James Dixon, <i>Norwich</i></li>
<li class="ul2">La Fayette S. Foster, <i>Hartford</i></li>
</ul>
</li>
<li class="ul1">Representatives
              <ul style="list-style-type:none">
<li class="ul2">Henry C. Deming, <i>Hartford</i></li>
<li class="ul2">Samuel L. Warner, <i>Middletown</i></li>
<li class="ul2">Augustus Brandegee, <i>New London</i></li>
<li class="ul2">John H. Hubbard, <i>Litchfield</i></li>
</ul>
</li>
</ul>
</li>
<li class="ulf">Delaware
          <ul style="list-style-type:none">
<li class="ul1">Senators
              <ul style="list-style-type:none">
<li class="ul2">George Read Riddle, <i>Wilmington</i></li>
<li class="ul2">Willard Saulsbury, <i>Georgetown</i></li>
</ul>
</li>
<li class="ul1">Representatives
              <ul style="list-style-type:none">
<li class="ul2">John A. Nicholson, <i>Dover</i></li>
</ul>
</li>
</ul>
</li>
<li class="ulf">Florida
          <ul style="list-style-type:none">
<li class="ul1">Senators
              <ul style="list-style-type:none">
<li class="ul2">Vacant<sup class="footnote-out"><a class="enref" href="#/chilashvol20267#en3" id="en3r" role="doc-noteref">2</a></sup></li>
<li class="ul2">Vacant<sup class="footnote-out"><a class="enref" href="#/chilashvol20267#en4" id="en4r" role="doc-noteref">3</a></sup></li>
</ul>
</li>
<li class="ul1">Representatives
              <ul style="list-style-type:none">
<li class="ul2">Vacant</li>
</ul>
</li>
</ul>
</li>
<li class="ulf">Georgia
          <ul style="list-style-type:none">
<li class="ul1">Senators
              <ul style="list-style-type:none">
<li class="ul2">Vacant</li>
</ul>
</li>
<li class="ul1">Representatives
              <ul style="list-style-type:none">
<li class="ul2">Vacant</li>
</ul>
</li>
</ul>
</li>
<li class="ulf">Illinois
          <ul style="list-style-type:none">
<li class="ul1">Senators
              <ul style="list-style-type:none">
<li class="ul2">Lyman Trumbull, <i>Chicago</i></li>
<li class="ul2">Richard Yates, <i>Jacksonville</i></li>
</ul>
</li>
<li class="ul1">Representatives
              <ul style="list-style-type:none">
<li class="ul2">John Wentworth, <i>Chicago</i></li>
<li class="ul2">John F. Farnsworth, <i>St. Charles</i></li>
<li class="ul2"><span aria-label="15" class="page" id="p15" role="doc-pagebreak"></span>Elihu B. Washburne, <i>Galena</i></li>
<li class="ul2">Abner C. Harding, <i>Monmouth</i></li>
<li class="ul2">Ebon C. Ingersoll, <i>Peoria</i></li>
<li class="ul2">Burton C. Cook, <i>Ottawa</i></li>
<li class="ul2">Henry P. H. Bromwell, <i>Charleston</i></li>
<li class="ul2">Shelby M. Cullom, <i>Springfield</i></li>
<li class="ul2">Lewis W. Ross, <i>Lewistown</i></li>
<li class="ul2">Anthony Thornton, <i>Shelbyville</i></li>
<li class="ul2">Samuel S. Marshall, <i>McLeansboro</i></li>
<li class="ul2">Jehu Baker, <i>Belleville</i></li>
<li class="ul2">Andrew J. Kuykendall, <i>Vienna</i></li>
<li class="ul2">At large—Samuel W. Moulton, <i>Shelbyville</i></li>
</ul>
</li>
</ul>
</li>
<li class="ulf">Indiana
          <ul style="list-style-type:none">
<li class="ul1">Senators
              <ul style="list-style-type:none">
<li class="ul2">Henry S. Lane, <i>Crawfordsville</i></li>
<li class="ul2">Thomas A. Hendricks, <i>Indianapolis</i></li>
</ul>
</li>
<li class="ul1">Representatives
              <ul style="list-style-type:none">
<li class="ul2">William E. Niblack, <i>Vincennes</i></li>
<li class="ul2">Michael C. Kerr, <i>New Albany</i></li>
<li class="ul2">Ralph Hill, <i>Columbus</i></li>
<li class="ul2">John H. Farquhar, <i>Brookville</i></li>
<li class="ul2">George W. Julian, <i>Centerville</i></li>
<li class="ul2">Ebenezer Dumont, <i>Indianapolis</i></li>
<li class="ul2">Daniel W. Voorhees,<sup class="footnote-out"><a class="enref" href="#/chilashvol20267#en5" id="en5r" role="doc-noteref">4</a></sup> <i>Terre Haute</i></li>
<li class="ul2">Henry D. Washburn,<sup class="footnote-out"><a class="enref" href="#/chilashvol20267#en6" id="en6r" role="doc-noteref">5</a></sup> <i>Clinton</i></li>
<li class="ul2">Godlove S. Orth, <i>La Fayette</i></li>
<li class="ul2">Schuyler Colfax, <i>South Bend</i></li>
<li class="ul2">Joseph H. Defrees, <i>Goshen</i></li>
<li class="ul2">Thomas N. Stillwell, <i>Andreson</i></li>
</ul>
</li>
</ul>
</li>
<li class="ulf">Iowa
          <ul style="list-style-type:none">
<li class="ul1">Senators
              <ul style="list-style-type:none">
<li class="ul2">James Harlan,<sup class="footnote-out"><a class="enref" href="#/chilashvol20267#en7" id="en7r" role="doc-noteref">6</a></sup> <i>Mount Pleasant</i></li>
<li class="ul2">Samuel J. Kirkwood,<sup class="footnote-out"><a class="enref" href="#/chilashvol20267#en8" id="en8r" role="doc-noteref">7</a></sup> <i>Iowa City</i></li>
<li class="ul2">James W. Grimes, <i>Burlington</i></li>
</ul>
</li>
<li class="ul1">Representatives
              <ul style="list-style-type:none">
<li class="ul2">James F. Wilson, <i>Fairfield</i></li>
<li class="ul2">Hiram Price, <i>Davenport</i></li>
<li class="ul2">William B. Allison, <i>Dubuque</i></li>
<li class="ul2">Josiah B. Grinnell, <i>Grinnell</i></li>
<li class="ul2"><span class="page" data-locator="p15"></span>John A. Kasson, <i>Des Moines</i></li>
<li class="ul2">Asahel W. Hubbard, <i>Sioux City</i></li>
</ul>
</li>
</ul>
</li>
<li class="ulf">Kansas
          <ul style="list-style-type:none">
<li class="ul1">Senators
              <ul style="list-style-type:none">
<li class="ul2">Samuel C. Pomeroy, <i>Atchison</i></li>
<li class="ul2">James H. Lane,<sup class="footnote-out"><a class="enref" href="#/chilashvol20267#en9" id="en9r" role="doc-noteref">8</a></sup> <i>Lawrence</i></li>
<li class="ul2">Edmund G. Ross,<sup class="footnote-out"><a class="enref" href="#/chilashvol20267#en10" id="en10r" role="doc-noteref">9</a></sup> <i>Lawrence</i></li>
</ul>
</li>
<li class="ul1">Representatives
              <ul style="list-style-type:none">
<li class="ul2">Sidney Clarke, <i>Lawrence</i></li>
</ul>
</li>
</ul>
</li>
<li class="ulf">Kentucky
          <ul style="list-style-type:none">
<li class="ul1">Senators
              <ul style="list-style-type:none">
<li class="ul2">Garrett Davis, <i>Paris</i></li>
<li class="ul2">James Guthrie, <i>Louisville</i></li>
</ul>
</li>
<li class="ul1">Representatives
              <ul style="list-style-type:none">
<li class="ul2">Lawrence S. Trimble, <i>Paducah</i></li>
<li class="ul2">Burwell C. Ritter, <i>Hopkinsville</i></li>
<li class="ul2">Henry Grider,<sup class="footnote-out"><a class="enref" href="#/chilashvol20267#en11" id="en11r" role="doc-noteref">10</a></sup> <i>Bowling Green</i></li>
<li class="ul2">Elijah Hise,<sup class="footnote-out"><a class="enref" href="#/chilashvol20267#en12" id="en12r" role="doc-noteref">11</a></sup> <i>Russellville</i></li>
<li class="ul2">Aaron Harding, <i>Greensburg</i></li>
<li class="ul2">Lovell H. Rousseau, <i>Louisville</i></li>
<li class="ul2">Green Clay Smith,<sup class="footnote-out"><a class="enref" href="#/chilashvol20267#en13" id="en13r" role="doc-noteref">12</a></sup> <i>Covington</i></li>
<li class="ul2">Andrew H. Ward,<sup class="footnote-out"><a class="enref" href="#/chilashvol20267#en14" id="en14r" role="doc-noteref">13</a></sup> <i>Cynthiana</i></li>
<li class="ul2">George S. Shanklin, <i>Nicholasville</i></li>
<li class="ul2">William H. Randall, <i>London</i></li>
<li class="ul2">Samuel McKee, <i>Mount Sterling</i></li>
</ul>
</li>
</ul>
</li>
<li class="ulf">Louisiana
          <ul style="list-style-type:none">
<li class="ul1">Senators
              <ul style="list-style-type:none">
<li class="ul2">Vacant</li>
</ul>
</li>
<li class="ul1">Representatives
              <ul style="list-style-type:none">
<li class="ul2">Vacant<sup class="footnote-out"><a class="enref" href="#/chilashvol20267#en15" id="en15r" role="doc-noteref">14</a></sup></li>
</ul>
</li>
</ul>
</li>
<li class="ulf"><span aria-label="16" class="page" id="p16" role="doc-pagebreak"></span>Maine
          <ul style="list-style-type:none">
<li class="ul1">Senators
              <ul style="list-style-type:none">
<li class="ul2">Lot M. Morrill, <i>Augusta</i></li>
<li class="ul2">William Pitt Fessenden, <i>Portland</i></li>
</ul>
</li>
<li class="ul1">Representatives
              <ul style="list-style-type:none">
<li class="ul2">John Lynch, <i>Portland</i></li>
<li class="ul2">Sidney Perham, <i>Paris</i></li>
<li class="ul2">James G. Blaine, <i>Augusta</i></li>
<li class="ul2">John H. Rice, <i>Foxcroft</i></li>
<li class="ul2">Frederick A. Pike, <i>Calais</i></li>
</ul>
</li>
</ul>
</li>
<li class="ulf">Maryland
          <ul style="list-style-type:none">
<li class="ul1">Senators
              <ul style="list-style-type:none">
<li class="ul2">Reverdy Johnson, <i>Baltimore</i></li>
<li class="ul2">John A. J. Creswell, <i>Elkton</i></li>
</ul>
</li>
<li class="ul1">Representatives
              <ul style="list-style-type:none">
<li class="ul2">Hiram McCullough, <i>Elkton</i></li>
<li class="ul2">John L. Thomas, Jr., <i>Baltimore</i></li>
<li class="ul2">Charles E. Phelps, <i>Baltimore</i></li>
<li class="ul2">Francis Thomas, <i>Frankville</i></li>
<li class="ul2">Benjamin G. Harris, <i>Leonardtown</i></li>
</ul>
</li>
</ul>
</li>
<li class="ulf">Massachusetts
          <ul style="list-style-type:none">
<li class="ul1">Senators
              <ul style="list-style-type:none">
<li class="ul2">Charles Sumner, <i>Boston</i></li>
<li class="ul2">Henry Wilson, <i>Natick</i></li>
</ul>
</li>
<li class="ul1">Representatives
              <ul style="list-style-type:none">
<li class="ul2">Thomas D. Eliot, <i>New Bedford</i></li>
<li class="ul2">Oakes Ames, <i>North Easton</i></li>
<li class="ul2">Alexander H. Rice, <i>Boston</i></li>
<li class="ul2">Samuel Hooper, <i>Boston</i></li>
<li class="ul2">John B. Alley, <i>Lynn</i></li>
<li class="ul2">Nathaniel P. Banks, <i>Waltham</i></li>
<li class="ul2">George S. Boutwell, <i>Groton</i></li>
<li class="ul2">John D. Baldwin, <i>Worcester</i></li>
<li class="ul2">William B. Washburn, <i>Greenfield</i></li>
<li class="ul2">Henry L. Dawes, <i>Pittsfield</i></li>
</ul>
</li>
</ul>
</li>
<li class="ulf">Michigan
          <ul style="list-style-type:none">
<li class="ul1">Senators
              <ul style="list-style-type:none">
<li class="ul2">Zacharia Chandler, <i>Detroit</i></li>
<li class="ul2">Jacob M. Howard, <i>Detroit</i></li>
</ul>
</li>
<li class="ul1">Representatives
              <ul style="list-style-type:none">
<li class="ul2">Fernando C. Beaman, <i>Adrian</i></li>
<li class="ul2">Charles Upson, <i>Coldwater</i></li>
<li class="ul2">John W. Longyear, <i>Lansing</i></li>
<li class="ul2">Thomas W. Ferry, <i>Grand Haven</i></li>
<li class="ul2">Rowland E. Trowbridge, <i>Birmingham</i></li>
<li class="ul2">John F. Driggs, <i>East Saginaw</i></li>
</ul>
</li>
</ul>
</li>
<li class="ulf"><span class="page" data-locator="p16"></span>Minnesota
          <ul style="list-style-type:none">
<li class="ul1">Senators
              <ul style="list-style-type:none">
<li class="ul2">Alexander Ramsey, <i>St. Paul</i></li>
<li class="ul2">Daniel S. Norton, <i>Winona</i></li>
</ul>
</li>
<li class="ul1">Representatives
              <ul style="list-style-type:none">
<li class="ul2">William Windom, <i>Winona</i></li>
<li class="ul2">Ignatius Donnelly, <i>Hastings</i></li>
</ul>
</li>
</ul>
</li>
<li class="ulf">Mississippi
          <ul style="list-style-type:none">
<li class="ul1">Senators
              <ul style="list-style-type:none">
<li class="ul2">Vacant</li>
</ul>
</li>
<li class="ul1">Representatives
              <ul style="list-style-type:none">
<li class="ul2">Vacant</li>
</ul>
</li>
</ul>
</li>
<li class="ulf">Missouri
          <ul style="list-style-type:none">
<li class="ul1">Senators
              <ul style="list-style-type:none">
<li class="ul2">John B. Henderson, <i>Louisiana</i></li>
<li class="ul2">B. Gratz Brown, <i>St. Louis</i></li>
</ul>
</li>
<li class="ul1">Representatives
              <ul style="list-style-type:none">
<li class="ul2">John Hogan, <i>St. Louis</i></li>
<li class="ul2">Henry T. Blow, <i>St. Louis</i></li>
<li class="ul2">Thomas E. Noell, <i>Perryville</i></li>
<li class="ul2">John R. Kelso, <i>Springfield</i></li>
<li class="ul2">Joseph W. McClurg, <i>Linn Creek</i></li>
<li class="ul2">Robert T. Van Horn, <i>Kansas City</i></li>
<li class="ul2">Benjamin F. Loan, <i>St. Joseph</i></li>
<li class="ul2">John F. Benjamin, <i>Shelbyville</i></li>
<li class="ul2">George W. Anderson, <i>Louisiana</i></li>
</ul>
</li>
</ul>
</li>
<li class="ulf">Nebraska
          <ul style="list-style-type:none">
<li class="ul1">Senators
              <ul style="list-style-type:none">
<li class="ul2">John M. Thayer,<sup class="footnote-out"><a class="enref" href="#/chilashvol20267#en16" id="en16r" role="doc-noteref">15</a></sup> <i>Omaha</i></li>
<li class="ul2">Thomas W. Tipton,<sup class="footnote-out"><a class="enref" href="#/chilashvol20267#en17" id="en17r" role="doc-noteref">16</a></sup> <i>Brownville</i></li>
</ul>
</li>
<li class="ul1">Representatives
              <ul style="list-style-type:none">
<li class="ul2">Turner M. Marquette,<sup class="footnote-out"><a class="enref" href="#/chilashvol20267#en18" id="en18r" role="doc-noteref">17</a></sup> <i>Plattsmouth</i></li>
</ul>
</li>
</ul>
</li>
<li class="ulf">Nevada
          <ul style="list-style-type:none">
<li class="ul1">Senators
              <ul style="list-style-type:none">
<li class="ul2">James W. Nye, <i>Carson City</i></li>
<li class="ul2">William M. Stewart, <i>Virginia City</i></li>
</ul>
</li>
<li class="ul1">Representatives
              <ul style="list-style-type:none">
<li class="ul2">Delos R. Ashley, <i>Virginia City</i></li>
</ul>
</li>
</ul>
</li>
<li class="ulf"><span aria-label="17" class="page" id="p17" role="doc-pagebreak"></span>New Hampshire
          <ul style="list-style-type:none">
<li class="ul1">Senators
              <ul style="list-style-type:none">
<li class="ul2">Daniel Clark,<sup class="footnote-out"><a class="enref" href="#/chilashvol20267#en19" id="en19r" role="doc-noteref">18</a></sup> <i>Manchester</i></li>
<li class="ul2">George G. Fogg,<sup class="footnote-out"><a class="enref" href="#/chilashvol20267#en20" id="en20r" role="doc-noteref">19</a></sup> <i>Concord</i></li>
<li class="ul2">Aaron H. Cragin, <i>Lebanon</i></li>
</ul>
</li>
<li class="ul1">Representatives
              <ul style="list-style-type:none">
<li class="ul2">Gilman Marston, <i>Exeter</i></li>
<li class="ul2">Edward H. Rollins, <i>Concord</i></li>
<li class="ul2">James W. Patterson, <i>Hanover</i></li>
</ul>
</li>
</ul>
</li>
<li class="ulf">New Jersey
          <ul style="list-style-type:none">
<li class="ul1">Senators
              <ul style="list-style-type:none">
<li class="ul2">William Wright,<sup class="footnote-out"><a class="enref" href="#/chilashvol20267#en21" id="en21r" role="doc-noteref">20</a></sup> <i>Newark</i></li>
<li class="ul2">Frederick T. Frelinghuysen,<sup class="footnote-out"><a class="enref" href="#/chilashvol20267#en22" id="en22r" role="doc-noteref">21</a></sup> <i>Newark</i></li>
<li class="ul2">John P. Stockton,<sup class="footnote-out"><a class="enref" href="#/chilashvol20267#en23" id="en23r" role="doc-noteref">22</a></sup> <i>Trenton</i></li>
<li class="ul2">Alexander G. Cattell,<sup class="footnote-out"><a class="enref" href="#/chilashvol20267#en24" id="en24r" role="doc-noteref">23</a></sup> <i>Camden</i></li>
</ul>
</li>
<li class="ul1">Representatives
              <ul style="list-style-type:none">
<li class="ul2">John F. Starr, <i>Camden</i></li>
<li class="ul2">William A. Newell, <i>Allentown</i></li>
<li class="ul2">Charles Sitgreaves, <i>Phillipsburg</i></li>
<li class="ul2">Andrew J. Rogers, <i>Newton</i></li>
<li class="ul2">Edwin R. V. Wright, <i>Hudson City</i></li>
</ul>
</li>
</ul>
</li>
<li class="ulf">New York
          <ul style="list-style-type:none">
<li class="ul1">Senators
              <ul style="list-style-type:none">
<li class="ul2">Ira Harris, <i>Albany</i></li>
<li class="ul2">Edwin D. Morgan, <i>New York City</i></li>
</ul>
</li>
<li class="ul1">Representatives
              <ul style="list-style-type:none">
<li class="ul2">Stephen Tabor, <i>Roslyn</i></li>
<li class="ul2">Teunis G. Bergen, <i>New Utrecht</i></li>
<li class="ul2">James Humphrey,<sup class="footnote-out"><a class="enref" href="#/chilashvol20267#en25" id="en25r" role="doc-noteref">24</a></sup> <i>Brooklyn</i></li>
<li class="ul2">John W. Hunter,<sup class="footnote-out"><a class="enref" href="#/chilashvol20267#en26" id="en26r" role="doc-noteref">25</a></sup> <i>Brooklyn</i></li>
<li class="ul2">Morgan Jones, <i>New York City</i></li>
<li class="ul2">Nelson Taylor, <i>New York City</i></li>
<li class="ul2">Henry J. Raymond, <i>New York City</i></li>
<li class="ul2"><span class="page" data-locator="p17"></span>John W. Chanler, <i>New York City</i></li>
<li class="ul2">James Brooks,<sup class="footnote-out"><a class="enref" href="#/chilashvol20267#en27" id="en27r" role="doc-noteref">26</a></sup> <i>New York City</i></li>
<li class="ul2">William E. Dodge,<sup class="footnote-out"><a class="enref" href="#/chilashvol20267#en28" id="en28r" role="doc-noteref">27</a></sup> <i>New York City</i></li>
<li class="ul2">William A. Darling, <i>New York City</i></li>
<li class="ul2">William Radford, <i>Yonkers</i></li>
<li class="ul2">Charles H. Winfield, <i>Goshen</i></li>
<li class="ul2">John H. Ketcham, <i>Dover</i></li>
<li class="ul2">Edwin N. Hubbell, <i>Coxsackie</i></li>
<li class="ul2">Charles Goodyear, <i>Schoharie</i></li>
<li class="ul2">John A. Griswold, <i>Troy</i></li>
<li class="ul2">Orlando Kellogg,<sup class="footnote-out"><a class="enref" href="#/chilashvol20267#en29" id="en29r" role="doc-noteref">28</a></sup> <i>Elizabethtown</i></li>
<li class="ul2">Robert S. Hale,<sup class="footnote-out"><a class="enref" href="#/chilashvol20267#en30" id="en30r" role="doc-noteref">29</a></sup> <i>Elizabethtown</i></li>
<li class="ul2">Calvin T. Hulburd, <i>Brasher Falls</i></li>
<li class="ul2">James M. Marvin, <i>Saratoga Springs</i></li>
<li class="ul2">Demas Hubbard, <i>Smyrna</i></li>
<li class="ul2">Addison H. Laflin, <i>Herkimer</i></li>
<li class="ul2">Roscoe Conkling, <i>Utica</i></li>
<li class="ul2">Sidney T. Holmes, <i>Morrisville</i></li>
<li class="ul2">Thomas T. Davis, <i>Syracuse</i></li>
<li class="ul2">Theodore M. Pomeroy, <i>Auburn</i></li>
<li class="ul2">Daniel Morris, <i>Penn Yan</i></li>
<li class="ul2">Giles W. Hotchkiss, <i>Binghamton</i></li>
<li class="ul2">Hamilton Ward, <i>Belmont</i></li>
<li class="ul2">Roswell Hart, <i>Rochester</i></li>
<li class="ul2">Burt Van Horn, <i>Newfane</i></li>
<li class="ul2">James M. Humphrey, <i>Buffalo</i></li>
<li class="ul2">Henry Van Aernam, <i>Franklinville</i></li>
</ul>
</li>
</ul>
</li>
<li class="ulf">North Carolina
          <ul style="list-style-type:none">
<li class="ul1">Senators
              <ul style="list-style-type:none">
<li class="ul2">Vacant</li>
</ul>
</li>
<li class="ul1">Representatives<sup class="footnote-out"><a class="enref" href="#/chilashvol20267#en31" id="en31r" role="doc-noteref">30</a></sup>
<ul style="list-style-type:none">
<li class="ul2">Vacant</li>
</ul>
</li>
</ul>
</li>
<li class="ulf">Ohio
          <ul style="list-style-type:none">
<li class="ul1">Senators
              <ul style="list-style-type:none">
<li class="ul2">John Sherman, <i>Jefferson</i></li>
<li class="ul2">Benjamin F. Wade, <i>Mansfield</i></li>
</ul>
</li>
<li class="ul1"><span aria-label="18" class="page" id="p18" role="doc-pagebreak"></span>Representatives
              <ul style="list-style-type:none">
<li class="ul2">Benjamin Eggleston, <i>Cincinnati</i></li>
<li class="ul2">Rutherford B. Hayes, <i>Cincinnati</i></li>
<li class="ul2">Robert C. Schenck, <i>Dayton</i></li>
<li class="ul2">William Lawrence, <i>Bellefontaine</i></li>
<li class="ul2">Frank C. Le Blond, <i>Celina</i></li>
<li class="ul2">Reader W. Clarke, <i>Batavia</i></li>
<li class="ul2">Samuel Shellabarger, <i>Springfield</i></li>
<li class="ul2">James R. Hubbell, <i>Delaware</i></li>
<li class="ul2">Ralph P. Buckland, <i>Fremont</i></li>
<li class="ul2">James M. Ashley, <i>Toledo</i></li>
<li class="ul2">Hezekiah S. Bundy, <i>Reeds Mill</i></li>
<li class="ul2">William E. Finck, <i>Somerset</i></li>
<li class="ul2">Columbus Delano, <i>Mount Vernon</i></li>
<li class="ul2">Martin Welker, <i>Wooster</i></li>
<li class="ul2">Tobias A. Plants, <i>Pomeroy</i></li>
<li class="ul2">John A. Bingham, <i>Cadiz</i></li>
<li class="ul2">Ephraim R. Eckley, <i>Carrolton</i></li>
<li class="ul2">Rufus P. Spalding, <i>Cleveland</i></li>
<li class="ul2">James A. Garfield, <i>Hiram</i></li>
</ul>
</li>
</ul>
</li>
<li class="ulf">Oregon
          <ul style="list-style-type:none">
<li class="ul1">Senators
              <ul style="list-style-type:none">
<li class="ul2">James W. Nesmith, <i>Salem</i></li>
<li class="ul2">George H. Williams, <i>Portland</i></li>
</ul>
</li>
<li class="ul1">Representative at Large
              <ul style="list-style-type:none">
<li class="ul2">James H. D. Henderson, <i>Eugene City</i></li>
</ul>
</li>
</ul>
</li>
<li class="ulf">Pennsylvania
          <ul style="list-style-type:none">
<li class="ul1">Senators
              <ul style="list-style-type:none">
<li class="ul2">Charles R. Buckalew, <i>Bloomsburg</i></li>
<li class="ul2">Edgar Cowan, <i>Greensburg</i></li>
</ul>
</li>
<li class="ul1">Representatives
              <ul style="list-style-type:none">
<li class="ul2">Samuel J. Randall, <i>Philadelphia</i></li>
<li class="ul2">Charles O’Neill, <i>Philadelphia</i></li>
<li class="ul2">Leonard Myers, <i>Philadelphia</i></li>
<li class="ul2">William D. Kelley, <i>Philadelphia</i></li>
<li class="ul2">M. Russell Thayer, <i>Chestnut Hill</i></li>
<li class="ul2">Benjamin M. Boyer, <i>Norristown</i></li>
<li class="ul2">John M. Broomall, <i>Media</i></li>
<li class="ul2">Sydenham E. Ancona, <i>Reading</i></li>
<li class="ul2">Thaddeus Stevens, <i>Lancaster</i></li>
<li class="ul2">Myer Strouse, <i>Pottsville</i></li>
<li class="ul2">Philip Johnson, <i>Easton</i></li>
<li class="ul2">Charles Denison, <i>Wilkes-Barre</i></li>
<li class="ul2">Ulysses Mercur, <i>Towanda</i></li>
<li class="ul2">George F. Miller, <i>Lewisburg</i></li>
<li class="ul2">Adam J. Glossbrenner, <i>York</i></li>
<li class="ul2"><span class="page" data-locator="p18"></span>Alexander H. Coffroth,<sup class="footnote-out"><a class="enref" href="#/chilashvol20267#en32" id="en32r" role="doc-noteref">31</a></sup> <i>Somerset</i></li>
<li class="ul2">William H. Koontz,<sup class="footnote-out"><a class="enref" href="#/chilashvol20267#en33" id="en33r" role="doc-noteref">32</a></sup> <i>Somerset</i></li>
<li class="ul2">Abraham A. Barker, <i>Edenburg</i></li>
<li class="ul2">Stephen F. Wilson, <i>Wellsboro</i></li>
<li class="ul2">Glenni W. Scofield, <i>Warren</i></li>
<li class="ul2">Charles V. Culver, <i>Franklin</i></li>
<li class="ul2">John L. Dawson, <i>Brownsville</i></li>
<li class="ul2">James K. Moorhead, <i>Pittsburgh</i></li>
<li class="ul2">Thomas Williams, <i>Pittsburgh</i></li>
<li class="ul2">George V. Lawrence, <i>Monongahela City</i></li>
</ul>
</li>
</ul>
</li>
<li class="ulf">Rhode Island
          <ul style="list-style-type:none">
<li class="ul1">Senators
              <ul style="list-style-type:none">
<li class="ul2">Henry B. Anthony, <i>Providence</i></li>
<li class="ul2">William Sprague, <i>Providence</i></li>
</ul>
</li>
<li class="ul1">Representatives
              <ul style="list-style-type:none">
<li class="ul2">Thomas A. Jenckes, <i>Providence</i></li>
<li class="ul2">Nathan F. Dixon, <i>Westerly</i></li>
</ul>
</li>
</ul>
</li>
<li class="ulf">South Carolina
          <ul style="list-style-type:none">
<li class="ul1">Senators
              <ul style="list-style-type:none">
<li class="ul2">Vacant</li>
</ul>
</li>
<li class="ul1">Representatives
              <ul style="list-style-type:none">
<li class="ul2">Vacant</li>
</ul>
</li>
</ul>
</li>
<li class="ulf">Tennessee<sup class="footnote-out"><a class="enref" href="#/chilashvol20267#en34" id="en34r" role="doc-noteref">33</a></sup>
<ul style="list-style-type:none">
<li class="ul1">Senators
              <ul style="list-style-type:none">
<li class="ul2">Joseph S. Fowler,<sup class="footnote-out"><a class="enref" href="#/chilashvol20267#en35" id="en35r" role="doc-noteref">34</a></sup> <i>Nashville</i></li>
<li class="ul2">David T. Patterson,<sup class="footnote-out"><a class="enref" href="#/chilashvol20267#en36" id="en36r" role="doc-noteref">35</a></sup> <i>Greeneville</i></li>
</ul>
</li>
<li class="ul1">Representatives
              <ul style="list-style-type:none">
<li class="ul2">Nathaniel G. Taylor,<sup class="footnote-out"><a class="enref" href="#/chilashvol20267#en37" id="en37r" role="doc-noteref">36</a></sup> <i>Happy Valley</i></li>
<li class="ul2">Horace Maynard,<sup class="footnote-out"><a class="enref" href="#/chilashvol20267#en38" id="en38r" role="doc-noteref">37</a></sup> <i>Knoxville</i></li>
<li class="ul2">William B. Stokes,<sup class="footnote-out"><a class="enref" href="#/chilashvol20267#en39" id="en39r" role="doc-noteref">38</a></sup> <i>Liberty</i></li>
<li class="ul2">Edmund Cooper,<sup class="footnote-out"><a class="enref" href="#/chilashvol20267#en40" id="en40r" role="doc-noteref">39</a></sup> <i>Shelbyville</i></li>
<li class="ul2">William B. Campbell,<sup class="footnote-out"><a class="enref" href="#/chilashvol20267#en41" id="en41r" role="doc-noteref">40</a></sup> <i>Lebanon</i></li>
<li class="ul2"><span aria-label="19" class="page" id="p19" role="doc-pagebreak"></span>Samuel M. Arnell,<sup class="footnote-out"><a class="enref" href="#/chilashvol20267#en42" id="en42r" role="doc-noteref">41</a></sup> <i>Columbia</i></li>
<li class="ul2">Isaac R. Hawkins,<sup class="footnote-out"><a class="enref" href="#/chilashvol20267#en43" id="en43r" role="doc-noteref">42</a></sup> <i>Huntingdon</i></li>
<li class="ul2">John W. Leftwich,<sup class="footnote-out"><a class="enref" href="#/chilashvol20267#en44" id="en44r" role="doc-noteref">43</a></sup> <i>Memphis</i></li>
</ul>
</li>
</ul>
</li>
<li class="ulf">Texas
          <ul style="list-style-type:none">
<li class="ul1">Senators
              <ul style="list-style-type:none">
<li class="ul2">Vacant</li>
</ul>
</li>
<li class="ul1">Representatives
              <ul style="list-style-type:none">
<li class="ul2">Vacant</li>
</ul>
</li>
</ul>
</li>
<li class="ulf">Vermont
          <ul style="list-style-type:none">
<li class="ul1">Senators
              <ul style="list-style-type:none">
<li class="ul2">Solomon Foot,<sup class="footnote-out"><a class="enref" href="#/chilashvol20267#en45" id="en45r" role="doc-noteref">44</a></sup> <i>Rutland</i></li>
<li class="ul2">George F. Edmunds,<sup class="footnote-out"><a class="enref" href="#/chilashvol20267#en46" id="en46r" role="doc-noteref">45</a></sup> <i>Burlington</i></li>
<li class="ul2">Jacob Collamer,<sup class="footnote-out"><a class="enref" href="#/chilashvol20267#en47" id="en47r" role="doc-noteref">46</a></sup> <i>Woodstock</i></li>
<li class="ul2">Luke P. Poland,<sup class="footnote-out"><a class="enref" href="#/chilashvol20267#en48" id="en48r" role="doc-noteref">47</a></sup> <i>St. Johnsbury</i></li>
</ul>
</li>
<li class="ul1">Representatives
              <ul style="list-style-type:none">
<li class="ul2">Frederick E. Woodbridge, <i>Vergennes</i></li>
<li class="ul2">Justin S. Morrill, <i>Strafford</i></li>
<li class="ul2">Portus Baxter, <i>Derby Line</i></li>
</ul>
</li>
</ul>
</li>
<li class="ulf">Virginia
          <ul style="list-style-type:none">
<li class="ul1">Senators
              <ul style="list-style-type:none">
<li class="ul2">Vacant</li>
</ul>
</li>
<li class="ul1">Representatives
              <ul style="list-style-type:none">
<li class="ul2">Vacant</li>
</ul>
</li>
</ul>
</li>
<li class="ulf">West Virginia
          <ul style="list-style-type:none">
<li class="ul1">Senators
              <ul style="list-style-type:none">
<li class="ul2">Peter G. Van Winkle, <i>Parkersburg</i></li>
<li class="ul2">Waitman T. Willey, <i>Morgantown</i></li>
</ul>
</li>
<li class="ul1">Representatives
              <ul style="list-style-type:none">
<li class="ul2">Chester D. Hubbard, <i>Wheeling</i></li>
<li class="ul2">George R. Latham, <i>Grafton</i></li>
<li class="ul2">Kellian V. Whaley, <i>Point Pleasant</i></li>
</ul>
</li>
</ul>
</li>
<li class="ulf"><span class="page" data-locator="p19"></span>Wisconsin
          <ul style="list-style-type:none">
<li class="ul1">Senators
              <ul style="list-style-type:none">
<li class="ul2">James R. Doolittle, <i>Racine</i></li>
<li class="ul2">Timothy O. Howe, <i>Green Bay</i></li>
</ul>
</li>
<li class="ul1">Representatives
              <ul style="list-style-type:none">
<li class="ul2">Halbert E. Paine, <i>Milwaukee</i></li>
<li class="ul2">Ithamar C. Sloan, <i>Janesville</i></li>
<li class="ul2">Amasa Cobb, <i>Mineral Point</i></li>
<li class="ul2">Charles A. Eldridge, <i>Fond du Lac</i></li>
<li class="ul2">Philetus Sawyer, <i>Oshkosh</i></li>
<li class="ul2">Walter D. McIndoe, <i>Wausau</i></li>
</ul>
</li>
</ul>
</li>
</ul>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-lash-vol2-0010.vue?61046e56